import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { getWhiteLabelForDealerStyle } from '@skytech/utils'
import { useSelector } from 'react-redux'
import VisibilitySensor from 'react-visibility-sensor'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'

const ListLoader: FC<{
  conditionSelector: () => boolean
  action: () => void
}> = ({ conditionSelector = () => true, action = () => {} }) => {
  const { whiteLabel } = useAppContext()
  const isVisible = useSelector(conditionSelector)

  if (!isVisible) return null

  const onChange = (isVisible: boolean) => isVisible && action()

  return (
    <VisibilitySensor onChange={onChange}>
      <div className="center p-6">
        <Button
          onClick={action}
          className="px-20 py-3 text-sm"
          whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
        >
          <Translation id="Load more results" />
        </Button>
      </div>
    </VisibilitySensor>
  )
}

export default ListLoader
